module.exports = __webpack_public_path__ + "img/李宇龙.6b6f13db.png";